import fullUrl from '../../utils/fullUrl';

export function createLandingPageInternationalSeoLinks() {
  return [
    {
      rel: 'alternate',
      href: 'https://tunein.com/?lang=es-US',
      hreflang: 'es-US',
    },
    {
      rel: 'alternate',
      href: 'https://tunein.com?lang=es-ES',
      hreflang: 'es-ES',
    },
    { rel: 'alternate', href: 'https://tunein.com/?lang=es', hreflang: 'es' },
    { rel: 'alternate', href: 'https://tunein.com/', hreflang: 'en' },
    { rel: 'alternate', href: 'https://tunein.com/', hreflang: 'x-default' },
  ];
}

export function createInternationalSeoLinks(canonicalPath) {
  return [
    {
      rel: 'alternate',
      href: `${fullUrl(canonicalPath)}?lang=es-US`,
      hreflang: 'es-US',
    },
    {
      rel: 'alternate',
      href: `${fullUrl(canonicalPath)}?lang=es-ES`,
      hreflang: 'es-ES',
    },
    {
      rel: 'alternate',
      href: `${fullUrl(canonicalPath)}?lang=es`,
      hreflang: 'es',
    },
    { rel: 'alternate', href: fullUrl(canonicalPath), hreflang: 'en' },
    { rel: 'alternate', href: fullUrl(canonicalPath), hreflang: 'x-default' },
  ];
}
